import { css } from 'styled-components';
import { map } from '../../breakpoint';
// Flex Direction:
export const validFlexDirectionValues = ['row', 'column', 'row-reverse', 'column-reverse'];
export const flexDirection = () => css`
  ${_ref => {
  let {
    flexDirection
  } = _ref;
  return map(flexDirection, val => val && css`
          flex-direction: ${val};
        `);
}};
`;
// Flex Wrap:
export const validFlexWrapValues = ['wrap', 'nowrap', 'wrap-reverse'];
export const flexWrap = () => css`
  ${_ref2 => {
  let {
    flexWrap
  } = _ref2;
  return map(flexWrap, val => val && css`
          flex-wrap: ${val};
        `);
}};
`;
export const flexGrow = () => css`
  ${_ref3 => {
  let {
    flexGrow
  } = _ref3;
  return map(flexGrow, val => val !== undefined && css`
          flex-grow: ${val};
        `);
}};
`;
export const flexShrink = () => css`
  ${_ref4 => {
  let {
    flexShrink
  } = _ref4;
  return map(flexShrink, val => val !== undefined && css`
          flex-shrink: ${val};
        `);
}};
`;
// Flex Align Values - shared between align-items and align-self:
export const validFlexAlignValues = ['center', 'flex-start', 'flex-end', 'stretch'];
// Align Items:
export const alignItems = () => css`
  ${_ref5 => {
  let {
    alignItems
  } = _ref5;
  return map(alignItems, val => val && css`
          align-items: ${val};
        `);
}};
`;
// Align Self:
export const alignSelf = () => css`
  ${_ref6 => {
  let {
    alignSelf
  } = _ref6;
  return map(alignSelf, val => val && css`
          align-self: ${val};
        `);
}};
`;
// Justify Content:
export const validJustifyContentValues = ['center', 'flex-start', 'flex-end', 'space-between', 'space-around', 'space-evenly'];
export const justifyContent = () => css`
  ${_ref7 => {
  let {
    justifyContent
  } = _ref7;
  return map(justifyContent, val => val && css`
          justify-content: ${val};
        `);
}};
`;